var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: _vm.to, params: {id: _vm.id } }}},[_c('img',{attrs:{"src":_vm.path}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }